(function () {
  function unhide(el) {
    if (el.style.display === 'none') {
      el.style.removeProperty('display');
    }
  }
  function watch(el) {
    if (el.dataset.priceFixWatched) return;
    el.dataset.priceFixWatched = '1';
    unhide(el);
    new MutationObserver(function () { unhide(el); }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }
  function scan() {
    document.querySelectorAll('.product__price .original, .product-item__price .original').forEach(watch);
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
})();
